const routes = [
  {
    path: '/questionSurvey',
    name: 'smartPark',
    component: () => import('./pages/Home'),
    // redirect: '/carAccessRecord/index',
    meta: {
      requireAuth: false
    },
    children: [
      {
        path: 'questionManage', // 调查问卷管理
        name: 'questionManage',
        component: () => import('./pages/QuestionManage'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
      {
        path: 'surveyManage', // 调查项管理
        name: 'surveyManage',
        component: () => import('./pages/SurveyManage'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
    ]
  }
]

export default routes